import { RotateCcwIcon, XIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

interface AgencyPreviewChatHeaderProps {
  onClose: () => void
  onReset: () => void
}

export const AgencyPreviewChatHeader = ({
  onClose,
  onReset,
}: AgencyPreviewChatHeaderProps): ReactNode => (
  <div className="agency-preview-chat-header flex items-center justify-between border-b px-4 py-3">
    <div>
      <h3 className="text-sm font-semibold">Test Chat</h3>
      <p className="text-xs text-muted-foreground">Preview your agency responses</p>
    </div>
    <div className="flex items-center gap-1">
      <Button
        variant="ghost"
        size="icon"
        onClick={onReset}
        className="agency-preview-chat-reset size-8"
        title="Reset conversation"
      >
        <RotateCcwIcon className="size-4" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        onClick={onClose}
        className="agency-preview-chat-close size-8"
      >
        <XIcon className="size-4" />
      </Button>
    </div>
  </div>
)

AgencyPreviewChatHeader.displayName = 'AgencyPreviewChatHeader'
